import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type EmailStatus as SchemaEmailStatus } from '../schemas/EmailStatus';
import { type EmailType as SchemaEmailType } from '../schemas/EmailType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const EmailStatusContentType = '' as const;
export type EmailStatusRequest = void;
export type EmailStatusResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaEmailStatus;
    };
};
export type EmailStatusResponseSuccess = EmailStatusResponses['200']['application/json'];
export type EmailStatusSearchParams = {
    email_type: SchemaEmailType;
};
export type EmailStatusPathParameters = undefined;
export const EmailStatusUrl = '/email/status' as const;
export const EmailStatusMethod = 'GET' as const;
export const getEmailStatusUrl = (_params?: EmailStatusPathParameters) => EmailStatusUrl;
